import React from "react";
import { PARTNER_MARKS } from "../components/PartnerMarks";

export default function Partners() {
  // Duplicate twice for a seamless infinite marquee
  const items = [...PARTNER_MARKS, ...PARTNER_MARKS];

  return (
    <section
      id="partenaires"
      data-testid="partners-section"
      className="relative bg-[#0A1326] border-y border-[#D4AF37]/15 py-14 md:py-16 overflow-hidden"
    >
      <div className="absolute inset-0 peul-pattern opacity-25 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-5 md:px-8 lg:px-12 mb-8 md:mb-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
          <div>
            <div className="overline text-[#D4AF37]">
              ── Partenaires technologiques
            </div>
            <h2 className="font-display text-[26px] sm:text-3xl md:text-4xl font-black tracking-tight mt-3 text-[#F5F5F5] leading-[1.1]">
              Aux côtés des leaders mondiaux de la cybersécurité.
            </h2>
          </div>
          <p className="text-[#F5F5F5]/65 max-w-sm text-[14px] sm:text-[15px]">
            Solutions certifiées, expertise éprouvée — nous déployons
            l'écosystème qui sécurise vos opérations.
          </p>
        </div>
      </div>

      <div className="relative marquee-fade">
        <div
          className="flex w-max ticker-track items-center"
          style={{ animationDuration: "55s" }}
        >
          {items.map((p, i) => (
            <div
              key={`${p.name}-${i}`}
              data-testid={`partner-${p.name.toLowerCase()}-${i}`}
              className="flex items-center justify-center px-8 sm:px-12 md:px-14 py-3 whitespace-nowrap min-h-[56px] hover:opacity-100 opacity-80 transition-opacity"
            >
              <p.Component />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
